import React from 'react';

const MobileMenuContext = React.createContext({visible: false,  actionDispatch: () => console.debug('dispatch action 2')});

export default MobileMenuContext;